module.exports = __webpack_public_path__ + "img/hkig-white.a4194e69.png";